import { computeValue } from "../../core";
import { $mergeObjects as __mergeObjects } from "../expression/object/mergeObjects";
const $mergeObjects = (collection, expr, options) => {
  const arr = computeValue(collection, expr, null, options);
  return __mergeObjects(null, arr, options);
};
export {
  $mergeObjects
};
